import React from 'react'
import { Trash2 } from 'react-feather'

import { useDocumentCardContext } from '@frame/ui-components/document-card/context'
import { Button } from '@frame/ui-primitives/button'

import { useDocumentsFlowContext } from '@documents/contexts/documents-flow-context'
import { DocumentTypeOption, FileUploadState } from '@documents/types'
import { DocumentCardDataAttribute } from '@frame/types'

type Props = {
  disabled?: boolean
  onDelete?: () => void
  setSelectedFileToRemove: () => void
}

export function DeleteButton({ onDelete, disabled, setSelectedFileToRemove }: Props) {
  const { fileUploadState, hasSupportedClassification } = useDocumentCardContext()
  const { selectedDocumentType } = useDocumentsFlowContext()

  const onClick = () => {
    // If failed, just delete without confirmation
    const isFailed = fileUploadState === FileUploadState.FAILED
    const expectSupportedType = selectedDocumentType === DocumentTypeOption.PAYSTUB_OR_W2

    if (isFailed || (expectSupportedType && !hasSupportedClassification)) {
      onDelete?.()
    } else {
      // Otherwise, set the selected file to remove which will trigger the confirmation popover
      setSelectedFileToRemove()
    }
  }

  return (
    <Button
      className="group"
      data-cy={DocumentCardDataAttribute.DELETE_BUTTON}
      Icon={() => <Trash2 className="pointer-events-none text-moss-500 transition-colors group-hover:text-moss-650" />}
      onClick={onClick}
      intent="secondary"
      border={false}
      size="small"
      disabled={disabled}
    />
  )
}
